/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { Switch, Route, useParams } from 'react-router-dom';
import { companyTrackerInitiativeRoutes } from '@routes/company-tracker/routes';
import { CustomDashboardContainer } from '../custom-dashboard';
import { StaticDashboardRoute } from './StaticDashboardRoute';
import './InsightsDashboard.scss';

const CustomDashboardRoute = () => {
  const { dashboardId } = useParams<{ dashboardId: string }>();
  return <CustomDashboardContainer key={dashboardId} />;
};

export const InsightRoute = () => {
  return (
    <Switch>
      <Route path={companyTrackerInitiativeRoutes.CUSTOM_DASHBOARD.path}>
        <CustomDashboardRoute />
      </Route>

      <Route>
        <StaticDashboardRoute />
      </Route>
    </Switch>
  );
};
